// extracted by mini-css-extract-plugin
export default {"heading":"SectionHeading_heading__hI5qu","marker":"SectionHeading_marker__51CGR","label":"SectionHeading_label__VZar5","plain":"SectionHeading_plain__cTrPY"};